import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import Input from "../../components/input";
import { toast } from "react-toastify";
import useAxiosInstance from "../../hooks/useAxios";
import FormRender from "../../components/FormRender";
import { TableCustom } from "../../components/Table";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
const InnerForm = ({ setTables }) => {
  const [formData, setFormData] = useState({
    report_id: 0,
    title: "",
  });

  const handleUpload = (e) => {
    e.preventDefault();
    var files = e.target.files, f = files[0];
    if (f !== null) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        let readedData = XLSX.read(data, { type: 'binary' });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        let dataParse = '';
        dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let formated_data = [];
        dataParse.forEach((row, index) => {
          if (index !== 0) { 
            formated_data.push(
              {
                id: uuid(),
                report_id: Number(row[0]) || 0, 
                title: row[1] || "", 
              }
            )
          }
        });

        if (formated_data.length > 0) {
          setTables(prev => [...prev, ...formated_data]);
          toast.success(`Successfully added ${formated_data.length} reports from file`);
          document.getElementById('file_upload_report_migration').value = null;
        } else {
          toast.error('No data found in the uploaded file or incorrect format');
        }
      };
      reader.readAsBinaryString(f)
    }
  };

  return (
    <div className="">
      <FormRender
        formData={formData}
        formSettings={[
          {
            label: "Report ID",
            type: "number",
            saveKey: "report_id",
          },
          {
            label: "title*",
            type: "text",
            saveKey: "title",
            options: [],
          },
        ]}
        setFormData={setFormData}
      />
      <button
        className="text-sm bg-black disabled:cursor-not-allowed text-white font-medium px-2 py-1 rounded-md mt-2"
        onClick={() => {
          setTables((prev) => [
            ...prev,
            { id: uuid(), ...formData, report_id: Number(formData.report_id) },
          ]);
        }}
      >
        +add
      </button>
      <div className="mt-4">
        <div className="text-sm font-semibold mb-2">Or upload CSV/Excel file</div>
        <p className='text-xs font-medium mb-2'>Expected sequence:- report_id || title</p>
        <input
          id='file_upload_report_migration'
          onChange={e => handleUpload(e)}
          className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
          type='file'
        />
        <div className='flex justify-end w-full'>
          <button
            className='bg-gray-300 text-black py-1 px-2 text-sm hover:shadow-lg text-center max-w-max rounded-lg mt-2'
            onClick={() => {
              document.getElementById('file_upload_report_migration').value = null
            }}>Reset</button>
        </div>
      </div>
    </div>
  );
};

const ReportMigration = () => {
  const axiosInstance = useAxiosInstance();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    transfer_to: "",
  });
  const [reportIds, setReportIds] = useState([]);
  const [response, setResponse] = useState({});
  const { organisation } = useSelector(e => e.globalAuth)
  const [selectedUserOrg, setSelectedUserOrg] = useState("");
  
  useEffect(()=>{
    setFormData(prev=>({...prev,organisation:selectedUserOrg}))
  },[selectedUserOrg])
  return (
    <div className="">
      <div className={` w-full justify-center p-5 ${"items-start "} flex`}>
        <div className="w-[676px] p-3 mt-5 border rounded-lg bg-white">
          <p className="text-2xl font-semibold mb-4">Migrate Report</p>
          <FormRender
            formData={formData}
            formSettings={[
              {
                label: "Username(Single Select Only)*",
                type: "user",
                saveKey: "transfer_to",
              },
              {
                label: "Organization*",
                type: "select",
                saveKey: "organisation",
                readonly:true
              },
            ]}
            setSelectedUserOrg={setSelectedUserOrg}
            setFormData={setFormData}
            select_options={
              { "organisation": Object?.keys(organisation || {})?.map(ot => ({ label: ot, value: ot })) || [] }
            }
          />
          <InnerForm setTables={setReportIds} />
          <TableCustom
            columns={[
              {
                label: "Report Id",
                key: "report_id",
                width: "5%",
              },
              {
                label: "Title",
                key: "title",
                width: "5%",
              },
            ]}
            data={{ data: reportIds }}
            loading={isLoading}
            handleEdit={null}
            handleDelete={(id) => {
              setReportIds((prev) => prev.filter((item) => item.id !== id));
            }}
            handleSelect={null}
            className="max-w-full"
          />

          <button
            disabled={isLoading}
            className="text-sm bg-black disabled:cursor-not-allowed text-white font-medium px-2 py-1 rounded-md mt-2"
            onClick={() => {
              setResponse({});
              setIsLoading(true);
              axiosInstance
                .post("/accounts/migrate_report/", {
                  ...formData,
                  transfer_to: Number(Object.keys(formData.transfer_to)[0]),
                  reports: reportIds,
                })
                .then((res) => {
                  setIsLoading(false);
                  setResponse(res.data.data);
                  if (res.data.status === "success") {
                    toast.success(res.data.message);
                  } else {
                    toast.info(res.data.message);
                  }
                })
                .catch((err) => {
                  setIsLoading(false);
                  console.log(err?.response?.data?.message);
                });
            }}
          >
            {isLoading ? "migrating...." : "Save"}
          </button>

          <div className="mt-3">
            <p className="text-base font-semibold">Status</p>
            {Object.keys(response).map((key) => {
              if (!response[key].length){
                return null
              }
              
              return (
                <>
                  <p className="text-sm font-semibold uppercase">
                    {key.split("_").join(" ")}
                  </p>
                  <div>
                    {response[key].map((it) => {
                      return (
                        <li key={it} className="text-xs font-medium">
                          {it}
                        </li>
                      );
                    })}
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReportMigration;